import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  TextField,
  DialogContentText,
  FormHelperText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  DatePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  LoadingBayOptions,
  SupplierOptions,
  BuildingOptions,
} from "../CONTANTS";
import { SET_EMPTY } from "config";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { saveVehicleInspectionChecklistForm } from "services/wvForms";
import { VEHICLE_SUPPLIER_CHECKLIST_FORM_SUCCESS } from "navigation/CONSTANTS";
import { useSelector } from "react-redux";
import { updateLang } from "i18n";
import { styled } from "@mui/system";
import WorkerDetailsFetcher from "../WorkerDetailsFetcher";

const StyledMainCard = styled(Card)({
  border: `1px solid #dadce0`,
  wordWrap: "break-word",
  pageBreakInside: "avoid",
  background: "#fff",
  borderRadius: 6,
  borderTopWidth: 10,
  borderTopColor: "#1976d2",
  marginTop: 10,
});

const StyledCard = styled(Card)({
  minWidth: "80%",
});

const StyledTextField = styled(TextField)({
  minWidth: "50%",
})

const StyledSelect = styled(Select)({
  minWidth: "50%",
})

const initialState = {
  building: "",
  hasPestEvidence: "",
  hasProductEvidence: "",
  isVehicleClean: "",
  hasWrongPallets: "",
  isTemperatureOk: "",
  hasOdours: "",
  vehicleRegistration: "",
  sealNumber: "",
  loadingBay: "",
  customer: "",
  palletsNumber: "",
  palletsSupplied: "",
  isPalletsQualityOk: "",
  comments: "",
  selectedDate: dayjs(),
  startTime: dayjs().hour(9).minute(0),
  endTime: dayjs().hour(17).minute(30),
  bookingReference: "",
  skuNumber: "",
  units: "",
  isSealsIntact: "",
  hasProductDamage: "",
  hasDriversPaperwork: "",
  hasPackagingDamage: "",
  isItemsCleaned: "",
  hasPalletsDamaged: "",
  isLoadRefused: "",
  isProductSecured: "",
  workerEmail: "",
  workerName: "",
  workerCountry: "",
  workerId: ""
};

const InboundSupplierVehicleForm = () => {
  const [processing, setProcessing] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [errorAlertDiag, setErrorAlertDiag] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialState);
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const inboundSupplierOptions = SupplierOptions(t);
  const loadingBayOptions = LoadingBayOptions(t);
  const buildingOptions = BuildingOptions;
  const INSPECTION_TYPE = "inbound";

    useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnvironment = document.querySelector(".imtime-testEnvironment");
    if (header) {
      header.style.display = "none";
    }
    if (testEnvironment) {
      testEnvironment.style.display = "none";
    }
  }, []);

  useEffect(() => {
    if (
      formData.building.trim() === SET_EMPTY ||
      formData.customer.trim() === SET_EMPTY ||
      formData.vehicleRegistration.trim() === SET_EMPTY ||
      formData.loadingBay.trim() === SET_EMPTY ||
      formData.palletsNumber.trim() === SET_EMPTY ||
      formData.palletsSupplied.trim() === SET_EMPTY ||
      formData.isSealsIntact.trim() === SET_EMPTY ||
      formData.isProductSecured.trim() === SET_EMPTY ||
      formData.isVehicleClean.trim() === SET_EMPTY ||
      formData.hasPestEvidence.trim() === SET_EMPTY ||
      formData.hasProductDamage.trim() === SET_EMPTY ||
      formData.hasDriversPaperwork.trim() === SET_EMPTY ||
      formData.hasPackagingDamage.trim() === SET_EMPTY ||
      formData.isItemsCleaned.trim() === SET_EMPTY ||
      formData.isPalletsQualityOk.trim() === SET_EMPTY ||
      formData.hasWrongPallets.trim() === SET_EMPTY ||
      formData.hasOdours.trim() === SET_EMPTY ||
      !formData.selectedDate ||
      !formData.startTime ||
      !formData.endTime ||
      formData.isTemperatureOk.trim() === SET_EMPTY ||
      formData.isLoadRefused.trim() === SET_EMPTY ||
      formData.workerId.trim() === SET_EMPTY ||
      formData.workerEmail.trim() === SET_EMPTY
    ) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [formData]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleProcessingOpen = () => {
    setProcessing(true);
  };
  const handleProcessingClose = () => {
    setProcessing(false);
  };

  const onSubmit = async () => {
    if ( !isSubmitDisabled) {
      let form = {
        inspectionType: INSPECTION_TYPE,
        building: formData.building.trim(),
        customer: formData.customer.trim(),
        selectedDate: formData.selectedDate.format("DD/MM/YYYY"),
        startTime: formData.startTime.format("hh:mm A"),
        endTime: formData.endTime.format("hh:mm A"),
        bookingReference: formData.bookingReference.trim(),
        vehicleRegistration: formData.vehicleRegistration.trim(),
        sealNumber: formData.sealNumber.trim(),
        loadingBay: formData.loadingBay.trim(),
        palletsNumber: formData.palletsNumber.trim(),
        skuNumber: formData.skuNumber.trim(),
        units: formData.units.trim(),
        palletsSupplied: formData.palletsSupplied.trim(),
        isSealsIntact: formData.isSealsIntact.trim(),
        hasProductEvidence: formData.hasProductEvidence.trim(),
        isProductSecured: formData.isProductSecured.trim(),
        isVehicleClean: formData.isVehicleClean.trim(),
        hasPestEvidence: formData.hasPestEvidence.trim(),
        hasProductDamage: formData.hasProductDamage.trim(),
        hasDriversPaperwork: formData.hasDriversPaperwork.trim(),
        hasPackagingDamage: formData.hasPackagingDamage.trim(),
        isItemsCleaned: formData.isItemsCleaned.trim(),
        hasPalletsDamaged: formData.hasPalletsDamaged.trim(),
        hasWrongPallets: formData.hasWrongPallets.trim(),
        isPalletsQualityOk: formData.isPalletsQualityOk.trim(),
        hasOdours: formData.hasOdours.trim(),
        isTemperatureOk: formData.isTemperatureOk.trim(),
        isLoadRefused: formData.isLoadRefused.trim(),
        comments: formData.comments.trim(),
        workerEmail: formData.workerEmail.trim(),
        workerCountry: formData.workerCountry.trim(),
        workerName: formData.workerName.trim(),
        workerId: formData.workerId.trim(),
      };
      handleProcessingOpen();
      console.log("Inbound Form", form);
      try {
        let inboundVehicleSupplierFormID =
          await saveVehicleInspectionChecklistForm(form);
        console.log(
          `outboundVehicleChecklist-form outBoundFormID is ${inboundVehicleSupplierFormID}`
        );
        handleProcessingClose();
        history.push(VEHICLE_SUPPLIER_CHECKLIST_FORM_SUCCESS);
      } catch (error) {
        console.log(`outboundVehicleChecklist-Form error ${error}`);
      }
    } else {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value) {
        newErrors[key] = "This field is required";
      }
        if(errors.workerId){
          newErrors.workerId = errors.workerId;
        }
        setErrors(newErrors);
      })
      setErrorAlertDiag(true);
    }
  };

  const { version } = useSelector((state) => state.translation.i18n);
  if (version && version > 1) {
    updateLang();
  }

  const onClear = () => {
    setFormData(initialState);
  };

  return (
    <>
      <Grid
          container
          direction="column"
          alignItems="stretch"
          spacing={2}
          sx={{ paddingLeft: "10px" }}
        >
          <Grid item>
            <StyledMainCard>
              <CardContent>
                <Typography variant="h6" gutterBottom color="textPrimary">
                  {t("other.lblInboundHeader")}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {t("other.lblInboundFormLabel")}
                </Typography>
              </CardContent>
            </StyledMainCard>
          </Grid>

          <WorkerDetailsFetcher 
            formData={formData} 
            setFormData={setFormData} 
            errors={errors}
            setErrors={setErrors}
          />

          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.building}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblBuildings")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.building}
                    onChange={handleChange}
                    name="building"
                  >
                    {buildingOptions.map((building) => (
                      <FormControlLabel
                        value={building.value}
                        control={<Radio />}
                        label={building.label}
                      />
                    ))}
                  </RadioGroup>
                  <FormHelperText>{errors.building}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblCustomer")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid item>
                  <FormControl variant="outlined">
                    <InputLabel id="support/customer-label">
                      {t("other.lblChoose")}
                    </InputLabel>
                    <StyledSelect
                      labelId="supplier/customer-label"
                      id="supplier/customer"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      value={formData.customer}
                      onChange={handleChange}
                      name="customer"
                      error={!!errors.customer}
                    >
                      {inboundSupplierOptions.map((supplier) => (
                        <MenuItem value={supplier.value}>
                          {supplier.label}
                        </MenuItem>
                      ))}
                    </StyledSelect>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errors.customer}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblSelectedDate")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid
                  container
                  direction="column"
                  alignItems="stretch"
                  spacing={1}
                >
                  <Grid item sx={{ width: 180 }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <InputLabel sx={{ marginTop: 1, marginBottom: 1.5 }}>
                      {t("other.lblDate")}
                      </InputLabel>
                      <DatePicker
                        value={formData.selectedDate}
                        onChange={(newValue) =>
                          handleChange({target : {name: "selectedDate", value : newValue}})
                        }
                        format="DD-MM-YYYY"
                        maxDate={dayjs()}
                        slotProps={{
                          textField: {
                            name: "selectedDate",
                            required: true,
                            placeholder: "DD-MM-YYYY",
                            error: !!errors.selectedDate,
                            helperText: errors.selectedDate,
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Grid>
                </Grid>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblStartTime")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={{ marginTop: 1, marginBottom: 1.5 }}>
                  {t("other.lblTime")}
                  </InputLabel>
                  <Stack spacing={2} sx={{ width: 170 }}>
                    <TimePicker
                      value={formData.startTime}
                      onChange={(newValue) =>
                        handleChange({target : {name: "startTime", value : newValue}})
                      }
                      name="startTime"
                      defaultValue={dayjs("2022-04-17T09:00")}
                      slotProps={{
                        textField: {
                          required: true,
                          errors: !!errors.startTime,
                          helperText: errors.startTime,
                        },
                      }}
                    />
                  </Stack>
                </LocalizationProvider>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblEndTime")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={{ marginTop: 1, marginBottom: 1.5 }}>
                  {t("other.lblTime")}
                  </InputLabel>
                  <Stack spacing={2} sx={{ width: 170 }}>
                    <TimePicker
                      value={formData.endTime}
                      onChange={(newValue) =>
                        handleChange({target : {name: "endTime", value : newValue}})
                      }
                      name="endTime"
                      defaultValue={dayjs("2022-04-17T15:30")}
                      slotProps={{
                        textField: {
                          required: true,
                          errors: !!errors.endTime,
                          helperText: errors.endTime,
                        },
                      }}
                    />
                  </Stack>
                </LocalizationProvider>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblBookingReference")}
                </Typography>
                <StyledTextField
                  id="booking"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.bookingReference}
                  onChange={handleChange}
                  name="bookingReference"
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {" "}
                  {t("other.lblVehicleRegistration")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <StyledTextField
                  id="vehicleRegistration"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.vehicleRegistration}
                  onChange={handleChange}
                  name="vehicleRegistration"
                  error={!!errors.vehicleRegistration}
                  helperText={errors.vehicleRegistration}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {" "}
                  {t("other.lblSealNumber")}
                </Typography>
                <StyledTextField
                  id="sealNumber"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.sealNumber}
                  onChange={handleChange}
                  name="sealNumber"
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblLoadingBay")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <Grid item>
                  <FormControl variant="outlined">
                    <InputLabel id="loadingBay">
                      {t("other.lblChoose")}
                    </InputLabel>
                    <StyledSelect
                      labelId="loadingBay-label"
                      id="loadingBay"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      value={formData.loadingBay}
                      onChange={handleChange}
                      name="loadingBay"
                      error={!!errors.loadingBay}
                    >
                      {loadingBayOptions.map((duration) => (
                        <MenuItem value={duration.value}>
                          {duration.label}
                        </MenuItem>
                      ))}
                    </StyledSelect>
                    <FormHelperText style={{ color: "#d32f2f" }}>
                      {errors.loadingBay}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblPalletsUnloaded")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <StyledTextField
                  id="palletsNumber"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.palletsNumber}
                  onChange={handleChange}
                  name="palletsNumber"
                  error={!!errors.palletsNumber}
                  helperText={errors.palletsNumber}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblSkuNumber")}
                </Typography>
                <StyledTextField
                  id="skuNumber"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.skuNumber}
                  onChange={handleChange}
                  name="skuNumber"
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblUnits")}
                </Typography>
                <StyledTextField
                  id="units"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.units}
                  onChange={handleChange}
                  name="units"
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblPalletsSupplied")}
                  <span style={{ color: "red" }}> *</span>
                </Typography>
                <StyledTextField
                  id="palletsSupplied"
                  label={t("other.lblYourAnswer")}
                  style={{ width: 250 }}
                  variant="standard"
                  value={formData.palletsSupplied}
                  onChange={handleChange}
                  name="palletsSupplied"
                  error={!!errors.palletsSupplied}
                  helperText={errors.palletsSupplied}
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.isSealsIntact}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblSealsIntact")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.isSealsIntact}
                    onChange={handleChange}
                    name="isSealsIntact"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="N/A"
                      control={<Radio />}
                      label="N/A"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.isSealsIntact}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblProductEvidence")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.hasProductEvidence}
                    onChange={handleChange}
                    name="hasProductEvidence"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.isProductSecured}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblProductSecured")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.isProductSecured}
                    onChange={handleChange}
                    name="isProductSecured"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.isProductSecured}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.isVehicleClean}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblVehicleCleanliness")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.isVehicleClean}
                    onChange={handleChange}
                    name="isVehicleClean"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.isVehicleClean}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasPestEvidence}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblPestEvidence")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.hasPestEvidence}
                    onChange={handleChange}
                    name="hasPestEvidence"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasPestEvidence}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasProductDamage}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblProductDamage")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.hasProductDamage}
                    onChange={handleChange}
                    name="hasProductDamage"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasProductDamage}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasDriversPaperwork}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblDriverPaperwork")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.hasDriversPaperwork}
                    onChange={handleChange}
                    name="hasDriversPaperwork"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                    <FormControlLabel
                      value="N/A"
                      control={<Radio />}
                      label="N/A"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasDriversPaperwork}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasPackagingDamage}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblPackageDamage")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.hasPackagingDamage}
                    onChange={handleChange}
                    name="hasPackagingDamage"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasPackagingDamage}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.isItemsCleaned}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblItemsCleaned")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.isItemsCleaned}
                    onChange={handleChange}
                    name="isItemsCleaned"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.isItemsCleaned}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasPalletsDamaged}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblPalletsDamage")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.hasPalletsDamaged}
                    onChange={handleChange}
                    name="hasPalletsDamaged"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasPalletsDamaged}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasWrongPallets}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblWrongPallets")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.hasWrongPallets}
                    onChange={handleChange}
                    name="hasWrongPallets"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasWrongPallets}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblPalletsQuality")}
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.isPalletsQualityOk}
                    onChange={handleChange}
                    name="isPalletsQualityOk"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.hasOdours}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblOdour")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.hasOdours}
                    onChange={handleChange}
                    name="hasOdours"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.hasOdours}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.isTemperatureOk}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblTemperature")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.isTemperatureOk}
                    onChange={handleChange}
                    name="isTemperatureOk"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.isTemperatureOk}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <FormControl error={!!errors.isLoadRefused}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblLoadRefused")}
                    <span style={{ color: "red" }}> *</span>
                  </Typography>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    value={formData.isLoadRefused}
                    onChange={handleChange}
                    name="isLoadRefused"
                  >
                    <FormControlLabel
                      value="Yes"
                      control={<Radio />}
                      label="Yes"
                    />
                    <FormControlLabel
                      value="No"
                      control={<Radio />}
                      label="No"
                    />
                  </RadioGroup>
                  <FormHelperText>{errors.isLoadRefused}</FormHelperText>
                </FormControl>
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <StyledCard>
              <CardContent>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  color="textPrimary"
                >
                  {t("other.lblCommentsInfo")}
                </Typography>
                <StyledTextField
                  id="comments"
                  label={t("other.lblYourAnswer")}
                  variant="standard"
                  fullWidth={true}
                  value={formData.comments}
                  onChange={handleChange}
                  name="comments"
                />
              </CardContent>
            </StyledCard>
          </Grid>
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              spacing={2}
            >
              <Grid item>
                <Button
                  type="Button"
                  variant="text"
                  sx={{ color: "#808080" }}
                  onClick={onClear}
                >
                  {t("other.lblClearForm")}
                </Button>
              </Grid>
              <Grid item>
                <Button variant="contained" color="primary" onClick={onSubmit}>
                  {t("pgHome.btEmpId")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      <Dialog
        open={processing}
        onClose={handleProcessingClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("other.lblSubmitting")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("other.lblPleaseWaitToSubmt")} <br /> <br />
            <Grid container justifyContent="center">
              <Grid item>
                <CircularProgress />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
        open={errorAlertDiag}
        onClose={() => {
          setErrorAlertDiag(false);
        }}
      >
        <DialogTitle id="error-dialog-title"> {t("other.tlError")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">
            {t("other.lblPleaseFillAllFields")} <br /> <br />
            <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setErrorAlertDiag(false);
                  }}
                >
                  {t("pgPunch.btnOK")}
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InboundSupplierVehicleForm;
